export const capitalizedLowercase = (s: string): string => {
  const toLowerCase = (str: string): string => str.toLowerCase();

  const capitalize = (str: string): string => {
    if (str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const sectionsArray = s.trim().split(' ').map(toLowerCase).map(capitalize);

  return sectionsArray.join(' ');
};

export const returnOneValueFromStringArrayDividedByComma = (value: string) => {
  return value.split(',').find((item) => item !== '');
};
